import { InteractionEventTrackingSchemas } from './Interaction';
import { AutomaticEventTrackingSchemas } from './Automatic';
import { ProductEventTrackingSchemas } from './Product';
import { ScreenEventTrackingSchemas } from './Screen';
import { ErrorEventTrackingSchemas } from './Error';

export const EventTrackingSchemas = {
  ...ScreenEventTrackingSchemas,
  ...ProductEventTrackingSchemas,
  ...InteractionEventTrackingSchemas,
  ...ErrorEventTrackingSchemas,
  ...AutomaticEventTrackingSchemas,
} as const;
